import { JobApplication } from 'types/job_applicationd'
import axiosForGigbaseBiz from '../../config'
import { DataResponse } from '../../response'
import { mergeURL } from '../lib'
import { PaginationParameter } from '../../common/pagination'

const resource = ['spotwork_jobs', 'job_applications']

export const requests = {
  fetchIndex: async (job_id: string, params: PaginationParameter) => {
    return await axiosForGigbaseBiz.get<DataResponse<JobApplication[]>>(
      mergeURL(resource[0], job_id.toString(), resource[1]),
      {
        params,
      },
    )
  },
  assign: async (job_id: string, id: string) => {
    return await axiosForGigbaseBiz.patch<DataResponse>(
      mergeURL(
        resource[0],
        job_id.toString(),
        resource[1],
        id.toString(),
        'assign',
      ),
    )
  },
  refuse: async (job_id: string, id: string) => {
    return await axiosForGigbaseBiz.patch<DataResponse>(
      mergeURL(
        resource[0],
        job_id.toString(),
        resource[1],
        id.toString(),
        'refuse',
      ),
    )
  },
}
